/* eslint-disable no-magic-numbers */
import { z } from 'zod';

export const pluginSchema = z.object({
  id: z.number().positive(),
  hash: z.string(),
  name: z.string(),
  version: z.string(),
  isPublic: z.boolean(),
  defaultInProject: z.array(z.string()),
  availableInProject: z.array(z.string()),
  withoutPanel: z.boolean().nullable().optional(),
  urls: z.array(z.string().min(1)),
});
